import React from 'react';
import PricingCalculatorForm from './PricingCalculatorForm';
import PricingCalculatorBanner from './PricingCalculatorBanner';
import FeeBreakdownModal from './FeeBreakdownModal';
import { PricingCalculator } from '@eventbrite/pricing-calculator';
import { gettext } from '@eventbrite/i18n';
import { PACKAGE_ONE, PACKAGE_TWO } from '../constants/main';
import {
    BANNER_TOGGLE_PACKAGE_ACTION,
    FEE_BREAKDOWN_MODAL_OPEN,
    GA_PRICING_CALC_CATEGORY,
} from '../constants/analytics';

const FREE_EVENT_TOTAL_TEXT = gettext(
    'Eventbrite is free to use for free events!',
);
const FREE_ATTENDEE_TOTAL_TEXT = '— —';
const getOppositeAssortment = (currentAssortment) =>
    currentAssortment === PACKAGE_ONE ? PACKAGE_TWO : PACKAGE_ONE;

const PricingCalculatorSection = ({
    currencySymbol,
    createActions,
    localeDefaultPlan,
    isAuthenticated,
    handleChangePlan,
    userPlan,
    trackEvent,
    defaultCurrency,
    currencyFormat,
}) => (
    <PricingCalculator
        assortment={localeDefaultPlan}
        defaultCurrency={defaultCurrency}
        currencyFormat={currencyFormat}
        currencySymbol={currencySymbol}
    >
        {({
            assortment,
            ticketPriceProps,
            ticketPrice,
            ticketQuantity,
            passOnFees,
            updateEventState,
            handleInputChange,
            calculateFees,
            eventTotal,
            attendeeTotal,
            isFree,
            isLoading,
            feeBreakdown,
            updateTicketPriceState,
            ticketPriceError,
            ticketQuantityError,
            impossiblePriceEncountered,
        }) => {
            const showChangePlanCTA =
                isAuthenticated && userPlan && userPlan !== assortment;

            const FORM_PROPS = {
                eventTotal: isFree ? FREE_EVENT_TOTAL_TEXT : eventTotal,
                attendeeTotal: isFree
                    ? FREE_ATTENDEE_TOTAL_TEXT
                    : attendeeTotal,
                handleCreate: createActions[assortment],
                ticketPriceProps,
                passOnFees,
                assortment,
                isFree,
                isLoading,
                calculateFees,
                updateEventState,
                handleInputChange,
                ticketPrice,
                ticketQuantity,
                currencySymbol,
                showChangePlanCTA,
                handleChangePlan,
                updateTicketPriceState,
                trackEvent,
                ticketPriceError,
                ticketQuantityError,
                impossiblePriceEncountered,
            };

            const BANNER_PROPS = {
                currentPackage: assortment,
                handleCTAClick: () => {
                    updateEventState(
                        { assortment: getOppositeAssortment(assortment) },
                        calculateFees,
                    );
                    trackEvent({
                        action: BANNER_TOGGLE_PACKAGE_ACTION,
                        category: GA_PRICING_CALC_CATEGORY,
                    });
                },
            };

            const feeBreakdownWithTotal = {
                ...feeBreakdown,
                attendeeTotal,
                passOnFees,
            };

            return (
                <div>
                    <FeeBreakdownModal {...feeBreakdownWithTotal}>
                        {(openModal) => (
                            <div>
                                <PricingCalculatorForm
                                    {...FORM_PROPS}
                                    openModal={() => {
                                        trackEvent({
                                            action: FEE_BREAKDOWN_MODAL_OPEN,
                                            category: GA_PRICING_CALC_CATEGORY,
                                        });
                                        openModal();
                                    }}
                                />
                                <PricingCalculatorBanner {...BANNER_PROPS} />
                            </div>
                        )}
                    </FeeBreakdownModal>
                </div>
            );
        }}
    </PricingCalculator>
);

export default PricingCalculatorSection;
